import React from "react";
import { JSONRenderer } from "../../JSONRenderer/JSONRenderer";
import { RelevantSectionsText } from "./IndicesResponseDisplay.styles";

export const IndicesResponseDisplay = ({ data, t }) => {
  return (
    <div>
      <RelevantSectionsText>{t("logs.relevantSections")}:</RelevantSectionsText>
      <JSONRenderer data={Array.isArray(data) ? data : data} />
    </div>
  );
};
